const STORAGE_KEY = 'opplevNorge2026_submittedAt';
const COOLDOWN_MS = 24 * 60 * 60 * 1000; // 1 day
// const COOLDOWN_MS = 15 * 1000; // 15 seconds

function isWithinCooldown() {
   const submittedAt = localStorage.getItem(STORAGE_KEY);
   if (!submittedAt) return false;
   return Date.now() - parseInt(submittedAt, 10) < COOLDOWN_MS;
}

function markSubmitted() {
   localStorage.setItem(STORAGE_KEY, Date.now().toString());
}

// Shares the window.__recaptchaScriptPromises cache across scripts on the same page so the
// reCAPTCHA script is fetched at most once per site key.
function loadRecaptchaScript(siteKey) {
   if (!siteKey) return Promise.reject(new Error('Mangler reCAPTCHA site key'));

   window.__recaptchaScriptPromises = window.__recaptchaScriptPromises || {};

   if (!window.__recaptchaScriptPromises[siteKey]) {
      window.__recaptchaScriptPromises[siteKey] = new Promise((resolve, reject) => {
         const script = document.createElement('script');
         script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}`;
         script.onload = resolve;
         script.onerror = () => {
            delete window.__recaptchaScriptPromises[siteKey];
            reject(new Error('Kunne ikke laste reCAPTCHA-scriptet'));
         };
         document.head.appendChild(script);
      });
   }

   return window.__recaptchaScriptPromises[siteKey];
}

const register = {
   form: document.getElementById('register-form'),
   name: document.getElementById('register-name'),
   phone: document.getElementById('register-phone'),
   address: document.getElementById('register-address'),
   store: document.getElementById('register-store'),
   answer: document.getElementById('register-answer'),
   submit: document.getElementById('register-submit'),
};

const submit = {
   container: document.querySelector('.submit-message'),
   success: document.getElementById('submit-success'),
   error: document.getElementById('submit-error'),
}

// recaptcha is opt-in per part instance - only active when "Krev reCAPTCHA-verifisering"
// is checked on the Form part, read from the data attributes it renders on the section
const recaptchaContainer = register.form?.closest('[data-require-recaptcha]') || null;
const requireRecaptcha = recaptchaContainer?.dataset.requireRecaptcha === 'true';
const recaptchaSiteKey = recaptchaContainer?.dataset.recaptchaSitekey || '';

if (requireRecaptcha) {
   // start loading (or reuse an already in-flight/loaded) recaptcha script as early as
   // possible, so it's ready by the time the user submits
   loadRecaptchaScript(recaptchaSiteKey);
}

const SVG_NS = 'http://www.w3.org/2000/svg';

// fixed seed so the trail's shape is reproducible on every load rather than different each time
const TRAIL_PATH_SEED = 9573;

function createSeededRandom(seed) {
   let state = seed;
   return function random() {
      state |= 0;
      state = (state + 0x6D2B79F5) | 0;
      let t = Math.imul(state ^ (state >>> 15), 1 | state);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
   };
}

function initScrollTrail() {
   const random = createSeededRandom(TRAIL_PATH_SEED);

   const container = document.querySelector('.main-container') || document.body;

   const svg = document.createElementNS(SVG_NS, 'svg');
   svg.classList.add('scroll-trail');
   svg.setAttribute('preserveAspectRatio', 'none');

   const maskId = 'scroll-trail-mask';
   const mask = document.createElementNS(SVG_NS, 'mask');
   mask.setAttribute('id', maskId);

   const maskRect = document.createElementNS(SVG_NS, 'rect');
   maskRect.setAttribute('x', '0');
   maskRect.setAttribute('y', '0');
   maskRect.setAttribute('fill', '#fff');
   mask.appendChild(maskRect);

   const defs = document.createElementNS(SVG_NS, 'defs');
   defs.appendChild(mask);

   const path = document.createElementNS(SVG_NS, 'path');
   path.classList.add('scroll-trail__path');
   path.setAttribute('mask', `url(#${maskId})`);

   svg.appendChild(defs);
   svg.appendChild(path);
   container.insertBefore(svg, container.firstChild);

   // waypoints are appended as the page grows rather than re-rolled, so the
   // trail's shape doesn't reshuffle every time an async widget changes the page height
   const points = [];
   let containerHeight = 0;

   function extendPoints(width, height) {
      const marginX = Math.max(width * 0.14, 30);
      const minX = marginX;
      const maxX = width - marginX;

      points.forEach((point) => {
         point.x = Math.min(maxX, Math.max(minX, point.x));
      });

      if (points.length === 0) {
         points.push({ x: width / 2, y: 30 });
      }

      let y = points[points.length - 1].y;
      while (y < height) {
         y += 130 + random() * 170;
         const prevX = points[points.length - 1].x;
         let x = prevX + (random() - 0.5) * (maxX - minX) * 1.12;
         // reflect off the margins instead of clamping to them, otherwise a few overshooting
         // steps in a row all get flattened to the same edge value - a straight run, not a wiggle
         if (x > maxX) x = maxX - (x - maxX);
         if (x < minX) x = minX + (minX - x);
         x = Math.min(maxX, Math.max(minX, x));
         points.push({ x, y: Math.min(y, height) });
      }
   }

   function pathFromPoints() {
      let d = `M ${points[0].x},${points[0].y}`;
      for (let i = 0; i < points.length - 1; i++) {
         const p0 = points[i];
         const p1 = points[i + 1];
         const midX = (p0.x + p1.x) / 2;
         const midY = (p0.y + p1.y) / 2;
         d += ` Q ${p0.x},${p0.y} ${midX},${midY}`;
      }
      const last = points[points.length - 1];
      d += ` L ${last.x},${last.y}`;
      return d;
   }

   function updateReveal() {
      // the cutoff's position within the viewport drifts from 10% down the screen at the top
      // of the page to 50% down by the bottom, so the trail visibly "catches up" as you approach
      // the destination, instead of sitting at a fixed spot in the viewport the whole way down
      const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const progress = Math.min(1, Math.max(0, window.scrollY / maxScroll));
      const viewportFraction = 0.1 + progress * 0.4;
      const revealed = Math.min(containerHeight, Math.max(0, window.scrollY + window.innerHeight * viewportFraction));
      maskRect.setAttribute('height', revealed);
   }

   function rebuildTrail() {
      const containerWidth = container.clientWidth;
      // clientHeight (not scrollHeight) so the trail can't extend past main-container's real
      // box when a module (eg. the poll bar) overflows it slightly, bleeding into the footer
      containerHeight = container.clientHeight;

      svg.setAttribute('viewBox', `0 0 ${containerWidth} ${containerHeight}`);
      svg.style.height = `${containerHeight}px`;
      maskRect.setAttribute('width', containerWidth);

      extendPoints(containerWidth, containerHeight);
      path.setAttribute('d', pathFromPoints());

      updateReveal();
   }

   let ticking = false;
   window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
         updateReveal();
         ticking = false;
      });
   }, { passive: true });

   // a ResizeObserver (rather than just a window 'resize'/'load' listener) catches the page
   // growing after async widgets (carousel, poll, random-message) mount their content late
let rebuildTimeout;
const scheduleRebuild = () => {
   clearTimeout(rebuildTimeout);
   rebuildTimeout = setTimeout(rebuildTrail, 150);
};

if (typeof ResizeObserver !== 'undefined') {
   new ResizeObserver(scheduleRebuild).observe(container);
} else {
   window.addEventListener('resize', scheduleRebuild);
   window.addEventListener('load', scheduleRebuild);
}
   rebuildTrail();
}

// wait for HTML to load
document.addEventListener('DOMContentLoaded', () => {
   initScrollTrail();

   // hide form immediately if within cooldown from a previous submission
   if (isWithinCooldown()) {
      register.form.classList.add('hidden');
      submit.container.classList.remove('hidden');
      submit.success.classList.remove('hidden');
   }

   // limit textarea to 6 rows
   const textarea = register.answer;
   const maxLines = 6;
   if (textarea) {
      textarea.addEventListener('keydown', function(event) {
         const lines = textarea.value.split('\n').length;

         if (event.key === 'Enter' && lines >= maxLines)
            event.preventDefault();
      });
   }

   // form
   if (register.submit) {
      const submitEntry = () => {
         const bodyParams = new URLSearchParams({
            table: 'OpplevNorgeKonkurranse2026',
            campaign: 'Opplev Norge',
            name: register.name.value,
            phone: register.phone.value,
            store: register.store.value,
         });

         return fetch('/_/service/no.tine.tine/entrySave', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: bodyParams,
         })
         .then((response) => {
            submit.container.classList.remove('hidden');

            if (response.status.toString().startsWith('2')) {
               // success
               markSubmitted();
               submit.success.classList.remove('hidden');
               submit.error.classList.add('hidden');
               register.form.classList.add('hidden');
            } else {
               // error
               submit.success.classList.add('hidden');
               submit.error.classList.remove('hidden');

               // console.error(`Register form: ${response}`);  - reenable when go live
            }
         })
         .catch((error) => {
            // console.error(`Register form: ${error}`);  - reenable when go live

            submit.container.classList.remove('hidden');
            submit.error.classList.remove('hidden');
            register.form.classList.add('hidden');
            submit.success.classList.add('hidden');
         });
      };

      register.submit.addEventListener('click', (event) => {
         // HTML validation
         if (register.form.checkValidity()) {
            event.preventDefault();

            if (isWithinCooldown()) {
               return;
            }

            if (!requireRecaptcha) {
               submitEntry();
               return;
            }

            loadRecaptchaScript(recaptchaSiteKey)
               .then(() => new Promise((resolve, reject) => {
                  grecaptcha.enterprise.ready(() => {
                     grecaptcha.enterprise.execute(recaptchaSiteKey, { action: 'CAMPAIGN_VOTE' })
                        .then(resolve, reject);
                  });
               }))
               .then((token) => fetch('/_/service/no.tine.tine/recaptcha', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ token }),
               }))
               .then((response) => response.json())
               .then((result) => {
                  if (!result.success) throw new Error(result.message || 'reCAPTCHA validation failed');

                  return submitEntry();
               })
               .catch((error) => {
                  // console.error(`Regsiter form: ${error}`);  - reenable when go live

                  submit.container.classList.remove('hidden');
                  submit.success.classList.add('hidden');
                  submit.error.classList.remove('hidden');
               });
         }
      });
   } else {
      console.info('No submit button defined');
   }
});
